import React from "react";
import { useHistory } from "react-router";
import { Button, Typography } from "antd";
import help from "../../../../Assets/Images/help.svg";
import onBoardingImg from "../../../../Assets/Images/004.jpg";

const { Title } = Typography;

export const ThankYouPage = () => {
  const history = useHistory();

  const handleStart = () => {
    localStorage.clear();
    history.push("/");
  };

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={onBoardingImg} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        <div className="thankyou_For_Choosing">
          <Title level={2}>Thank you for choosing SanAttest</Title>
          <h5>
            We’ve just the right plan for the businesses with multiple locations
            and large set of employees like yours.
          </h5>
          <div className="iconBlk text-center pt-4 pb-4">
            <img src={help} alt="" />
          </div>
          <p>
            Our team will get in touch with you in next 72 hours and help you
            get your locations and employees setup on SanAttest!
          </p>
          <div className="pt-5 d-flex justify-content-center">
            <Button
              type="primary"
              shape="round"
              size="large"
              className="mr-4"
              onClick={handleStart}
            >
              Back to home
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
